import { Observable } from 'rxjs';
import { Breed, CatalogResponse, CirculationZone, Country, PetQuestion } from '../../interfaces/initial-data/initial-data.interface';

export abstract class InitialDataRepository {

    abstract getAllInitialData(): Observable<CatalogResponse>;
    abstract getCountries(): Observable<Country[]>;
    abstract getCirculationZones(): Observable<CirculationZone[]>;
    abstract getBreeds(): Observable<Breed[]>;
    abstract getPetQuestions(): Observable<PetQuestion[]>;  

}   